import type {
    NonSkuGemstoneFragment,
    NonSkuLabGrownFragment,
    RingBuilderMountEngagementRingFragment,
    StoneFragment,
} from '@/graphql/api'
import { assertNever } from '@/helpers'

export type RingBuilderRingTypes = RingBuilderMountEngagementRingFragment

export type RingBuilderCentreStoneShapeConstraint =
    RingBuilderRingTypes['centreStoneConstraints']['shape']

export type RingBuilderStoneTypes =
    | StoneFragment
    | NonSkuGemstoneFragment
    | NonSkuLabGrownFragment

export type RecommendationsCategory =
    | 'natural-diamonds'
    | 'lab-grown-diamonds'
    | 'gemstones'

// TODO translate
export const getStoneCategory = (
    stone: RingBuilderStoneTypes | null
): string => {
    if (!stone) {
        return ''
    }

    switch (stone.__typename) {
        case 'GemsApi_Stone':
            return 'Natural Diamond'
        case 'NonSkuLabGrown':
            return 'Lab-Grown Diamond'
        case 'NonSkuGemstone':
            return `Natural ${stone.color.translation.name} ${stone.crystal.translation.name}`
        default:
            return assertNever(stone, '')
    }
}

export const getStoneColorAndClarity = (
    stone: RingBuilderStoneTypes | null
): string => {
    if (!stone) {
        return ''
    }

    switch (stone.__typename) {
        case 'GemsApi_Stone':
            return `${
                stone.colorWithInfo.info?.translation.name ||
                stone.colorWithInfo.code
            }, ${
                stone.clarityWithInfo.info?.translation.name ||
                stone.clarityWithInfo.code
            }`
        case 'NonSkuLabGrown':
            return `${stone.color.translation.name}, ${stone.clarity.translation.name}`
        case 'NonSkuGemstone':
            return `${stone.colorGrade.translation.name}, ${stone.clarity.translation.name}`
        default:
            return assertNever(stone, '')
    }
}

export const getStoneShape = (stone: RingBuilderStoneTypes | null): string => {
    if (!stone) {
        return ''
    }

    switch (stone.__typename) {
        case 'GemsApi_Stone':
            return (
                stone.shapeWithInfo.info?.translation.name ||
                stone.shapeWithInfo.code
            )
        case 'NonSkuLabGrown':
        case 'NonSkuGemstone':
            return stone.shape.translation.name
        default:
            return assertNever(stone, '')
    }
}

export const getStoneWeight = (stone: RingBuilderStoneTypes | null): string => {
    if (!stone) {
        return ''
    }

    let weight = 0

    switch (stone.__typename) {
        case 'GemsApi_Stone':
            weight = stone.weight
            break
        case 'NonSkuLabGrown':
        case 'NonSkuGemstone':
            weight = Number(stone.caratWeight)
            break
        default:
            assertNever(stone, stone)
    }

    return `${weight.toFixed(2)}ct`
}
